/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "befbd97d21ad8476cd83c22e5efeb5b9136939f7";
